import React from "react";

// Use React.forwardRef to pass the ref to the underlying children
const Container = React.forwardRef(({ className, children }, ref) => {
  return (
    <div ref={ref} className={` container mx-auto ${className || ""}`}>
      {children}
    </div>
  );
});

export default Container;
